// Assets
import { Routes, Route, useLocation } from "react-router-dom";
import React, { lazy, useEffect, useState } from "react";
import { getSeoDataApi } from "../../../api/seo/seo";
import Loadable from "../router/loadable.jsx";

const Book = Loadable(lazy(() => import("../../../pages/franchise/home/HomeF.jsx")));
const Adminpanel = Loadable(lazy(() => import("../../../common/franchise/pages/Adminpanel.jsx")));
const OfferInfo = Loadable(lazy(() => import("../../help/offer-information.jsx")));
const HomeScreen = Loadable(lazy(() => import("../../../AppHomeScreen")));
const NotFound = Loadable(lazy(() => import("../../restuarant-page/error/error")));
const GuideFusion = Loadable(lazy(() => import("../../help/guid-fusion.jsx")));
const MyAccount = Loadable(lazy(() => import("../../myaccount/myaccount-layout.jsx")));
const Orderstatus = Loadable(lazy(() => import("../../myaccount/components/orderstatus/orderstatus.jsx")));
const Orderstatusskle = Loadable(lazy(() => import("../../myaccount/components/orderstatus/Orderstatusskle.jsx")));

const WalletTC = Loadable(lazy(() => import("../../myaccount/components/wallet-tc/wallet-tc.jsx")));
const WalletPage = Loadable(lazy(() => import("../../myaccount/components/wallet/wallet.jsx")));
const Savedcard = Loadable(lazy(() => import("../../myaccount/components/wallet/savedcard.jsx")));
const Addcard = Loadable(lazy(() => import("../../myaccount/components/wallet/addcard.jsx")));
const Addressbook = Loadable(lazy(() => import("../../myaccount/components/addressbook/addressbook.jsx")));
const Myorder = Loadable(lazy(() => import("../../myaccount/components/myorder/myorder.jsx")));
const Orderdetail = Loadable(lazy(() => import("../../myaccount/components/myorder/orderdetail.jsx")));

const StuartTrack = Loadable(lazy(() => import("../../myaccount/components/orderstatus/components/stuart-track.jsx")));
const Tablebooking = Loadable(lazy(() => import("../../myaccount/components/Tablebooking/tablebooking.jsx")));
const FeedbackForm = Loadable(lazy(() => import("../../../common/feedBack/feedBack.js")));
const CommonWalletTC = Loadable(lazy(() => import("../../../common/wallet-tc/wallet-tc.jsx")));
const Profile = Loadable(lazy(() => import("../../myaccount/components/profile/profile.jsx")));
const PrivacyPolicy = Loadable(lazy(() => import("../home/other/privacypolicy.jsx")));

const Allergy = Loadable(lazy(() => import("../home/other/allergy.jsx")));
const Terms = Loadable(lazy(() => import("../home/other/terms.jsx")));
const WalletHistory = Loadable(lazy(() => import("../../../pages/myaccount/components/wallet/history.jsx")));
const MyOrder = Loadable(lazy(() => import("../../../pages/myaccount/components/myorder/myorder")));
const Home = Loadable(lazy(() => import("../home/HomeF.jsx")));
const CheckoutPage = Loadable(lazy(() => import("../../../pages/checkout/checkoutV2")));
const Help = Loadable(lazy(() => import("../../../pages/help/help.jsx")));
const WithOrder = Loadable(lazy(() => import("../../../pages/help/with-order")));
const AccountOptions = Loadable(lazy(() => import("../../../pages/help/account-options")));
const FilterList = Loadable(lazy(() => import("../../franchise/filterlist/List.jsx")));

const MenuPage = Loadable(lazy(() => import("../../../pages/menu/menu-page.jsx")));
const AllMenu = Loadable(lazy(() => import("../../../pages/menu/menu.jsx")));
const MenuAbout = Loadable(lazy(() => import("../../../pages/menu/about.jsx")));
const MenuReview = Loadable(lazy(() => import("../../../pages/menu/review.jsx")));
const Gpay = Loadable(lazy(() => import("../../../components/PaymentForm")));
const Partners = Loadable(lazy(() => import("../../../pages/partners-terms/partners-terms.jsx")));
const Brand = Loadable(lazy(() => import("../../../pages/our-brand/our-brand.jsx")));
const Stuart = Loadable(lazy(() => import("../../../pages/stuartT&C/stuart")));
const Faq = Loadable(lazy(() => import("../../../pages/faq/faq.jsx")));

const Cookies = Loadable(lazy(() => import("../../../pages/cookies/cookies")));
const Refund = Loadable(lazy(() => import("../../../pages/refund-expired/refund")));
const Contactless = Loadable(lazy(() => import("../../../pages/contactless-dining/contactless")));
const Cardrefund = Loadable(lazy(() => import("../../../pages/card-refund/card-refund")));
const Aboutus = Loadable(lazy(() => import("../../../pages/aboutus/aboutus")));
const Career = Loadable(lazy(() => import("../../../pages/career/career")));
const Becomepartner = Loadable(lazy(() => import("../../../pages/become-partner/becomepartner")));
const Leadsignup = Loadable(lazy(() => import("../../../pages/leadsignup/leadsignup")));
const AllArea = Loadable(lazy(() => import("../../../pages/all-area/allarea")));
const AllCuisines = Loadable(lazy(() => import("../../../pages/all-cuisines/all-cuisines")));
const Reseller = Loadable(lazy(() => import("../../../pages/reseller/reseller")));
const Blog = Loadable(lazy(() => import("../../../pages/blog/blog")));
const UploadMenu = Loadable(lazy(() => import("../../../pages/restuarant-page/home/UploadMenu.jsx")));
const Tablebookingmenu = Loadable(lazy(() => import("../../../pages/menu/tablebookingmenu")));
const MenuProductDetail = Loadable(lazy(() => import("../../../pages/menu/menuDetail")));
const MenuPageShopping = Loadable(lazy(() => import("../../../pages/menu/menuShopingPage")));
const Rateus = Loadable(lazy(() => import("../../../pages/rate-us/rate-us")));
const Tablebookingpayment = Loadable(lazy(() => import("../../../pages/tablebookingpayment/tablebookingpayment")));
const Checkoutpageskele = Loadable(lazy(() => import("../../../pages/checkout/Checkoutpageskeleton")));
const BlogDetail = Loadable(lazy(() => import("../../../pages/blogdetails/blogdetails")));
const CheckoutPageV1 = Loadable(lazy(() => import("../../../pages/checkout/checkout")));
const LeadForm = Loadable(lazy(() => import("../../../pages/franchise/leadform/LeadMainFile.jsx")));

const Routing = (params) => {
  const [analyticCode, setAnalyticCode] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = {
          domain: window.location.hostname,
        };
        const apiResponse = await getSeoDataApi(formData);
        if (apiResponse?.data?.status === false) {
          // Handle error condition
          console.error(
            "Error fetching sitemap data:",
            apiResponse.data.message
          );
        } else {
          // Handle success condition
          setAnalyticCode(apiResponse.data.message.analytic_code); // Update sitemap state with the fetched data
        }
      } catch (error) {
        console.error("Error fetching sitemap data:", error);
      }
    };

    fetchData(); // Call fetchData when the component mounts
  }, []);

  const location = useLocation();
  const loginCheck1 = localStorage.getItem("isLoggedIn");
  const loginCheck = loginCheck1 === "true";

  useEffect(() => {
    if (analyticCode) {
      // Add the Google Analytics script to the document head
      const script = document.createElement("script");
      script.async = true;
      script.src =
        `https://www.googletagmanager.com/gtag/js?id=` + analyticCode;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", analyticCode);

      // Track page views
      gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });

      // Cleanup function to remove the script
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [analyticCode, location]);

  const RoutingDatas = [
    { url: "/", element: <Home /> },
    { url: "/login", element: <Home /> },
    { url: "/app", element: loginCheck ? <Home /> : <HomeScreen /> },
    { url: "*", element: <NotFound /> },
    { url: "/Admin", element: <Adminpanel /> },
    { url: "/book", element: <Book /> },
    { url: "/help", element: <Help /> },
    { url: "/help-with-order", element: <WithOrder /> },
    { url: "/account-options", element: <AccountOptions /> },
    { url: "/offer-information", element: <OfferInfo /> },
    { url: "/guide-fusion", element: <GuideFusion /> },
    { url: "/list", element: <FilterList /> },
    { url: "/list", element: <FilterList /> },
    { url: "/privacy", element: <PrivacyPolicy />, },
    { url: "/terms", element: <Terms />, },
    { url: "/allergy", element: <Allergy />, },
    { url: "/ordernow", element: <Home /> },
    { url: "/accountdeletion", element: <Home /> },
    { url: "/gpay", element: <Gpay /> },
    { url: "/partner-terms", element: <Partners /> },
    { url: "/our-brand", element: <Brand /> },
    { url: "/stuart-delivery", element: <Stuart /> },
    { url: "/faq", element: <Faq /> },

    { url: "/cookies", element: <Cookies /> },
    { url: "/refundlinkexpired", element: <Refund /> },
    { url: "/contactlessdinning", element: <Contactless /> },
    { url: "/cardrefund", element: <Cardrefund /> },
    { url: "/about", element: <Aboutus /> },
    { url: "/career", element: <Career /> },
    { url: "/partner", element: <Becomepartner /> },

    { url: "/signup", element: <Leadsignup /> },
    { url: "/area", element: <AllArea /> },
    { url: "/cuisines", element: <AllCuisines /> },
    { url: "/reseller", element: <Reseller /> },
    { url: "/blog", element: <Blog /> },
    { url: "/menus", element: <UploadMenu /> },
    { url: "/become-franchise", element: <LeadForm /> },
  ];

  const MyAccountRouts = [
    {
      moblink: true,
      url: "/myaccount",
      element: <MyAccount />,
      subpaths: [
        {
          url: "profile",
          element: <Profile />,
        },
        {
          url: "orderstatus",
          element: <Orderstatus />,
        },
        {
          url: "Orderstatusskle",
          element: <Orderstatusskle />,
        },
        {
          url: "wallet-tc",
          element: <WalletTC />,
        },
        {
          url: "wallet",
          element: <WalletPage />,
        },
        {
          url: "savedcards",
          element: <Savedcard />,
        },
        {
          url: "addcard",
          element: <Addcard />,
        },
        {
          url: "wallethistory",
          element: <WalletHistory />,
        },
        {
          url: "addressbook",
          element: <Addressbook />,
        },
        {
          url: "myorder",
          element: <Myorder />,
        },
        {
          url: "orderdetail",
          element: <Orderdetail />,
        },
        {
          url: "stuarttrack",
          element: <StuartTrack />,
        },
        {
          url: "tablebooking",
          element: <Tablebooking />,
        }, {
          url: "yourorder",
          element: <MyOrder />,
        },
        {
          url: "help",
          element: <Help />,
        },
        {
          url: "feedbackmyaccount",
          element: <FeedbackForm />,
        },
        {
          url: "termsandcondition",
          element: <CommonWalletTC />,
        },
      ],
    },
  ];

  return (
    <>
      <>
        <Routes>
          {RoutingDatas.map((RoutingData, index) => (
            <Route
              key={index}
              exact
              path={RoutingData.url}
              element={RoutingData.element}
            />
          ))}
          {MyAccountRouts.map((MyAccountRout, index) => (
            <Route
              key={index}
              path={MyAccountRout.url}
              element={MyAccountRout.element}
            >
              <Route index element={<Profile />} />
              {MyAccountRout.subpaths.map((subpath, subIndex) => (
                <Route
                  key={subIndex}
                  path={subpath.url}
                  element={subpath.element}
                />
              ))}
            </Route>
          ))}
          {MyAccountRouts[0].subpaths.map((subpath, index) => (
            <Route
              key={index}
              path={"/" + subpath.url}
              element={subpath.element}
            />
          ))}
          <Route path="/:path" element={<MenuPage />}>
            <Route index element={<AllMenu />} />
            <Route path="menu" element={<AllMenu />} />
            <Route path="review" element={<MenuReview />} />
            <Route path="about" element={<MenuAbout />} />
            <Route path="tablebook" element={<Tablebookingmenu />} />
          </Route>
          <Route path="/:path/checkout" element={<CheckoutPage />} />
          <Route path="/:path/product/:id" element={<MenuProductDetail />} />
          <Route path="/:path/shopping" element={<MenuPageShopping />} />
          <Route path="/:path/rateus/:orderId" element={<Rateus />} />
          <Route path="tablebookingpayment" element={<Tablebookingpayment />} />
          <Route path="/:path/Checkoutpageskeleton" element={<Checkoutpageskele />} />
          <Route path="/blog/:path" element={<BlogDetail />} />
          <Route path="/:path/oldcheckout" element={<CheckoutPageV1 />} />

        </Routes>
      </>
    </>
  );
};
export default Routing;
